
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mi-cuenta/[[...slug]]",
      function () {
        return require("private-next-pages/mi-cuenta/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mi-cuenta/[[...slug]]"])
      });
    }
  